import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArchiveDocumentsBoxBig16 } from 'shared/assets/icons';

import { MetaInteraction } from '../meta-interaction';

export type MetaArchiveHabitProps = {
  onArchive: () => void;
  isArchived?: boolean;
};

export const MetaArchiveHabit: React.FC<MetaArchiveHabitProps> = ({
  onArchive,
  isArchived,
}) => {
  const { t } = useTranslation();

  const label = isArchived
    ? t('context-menus.task.labels.de-archive')
    : t('general.labels.archive');

  return (
    <MetaInteraction
      icon={ArchiveDocumentsBoxBig16}
      label={label}
      placeholder={label}
      onClick={onArchive}
    />
  );
};
